import React, { useState, useRef } from "react";
import { ToasterService } from "../../../../../services/toaster/toaster.service";
import { FormGridField } from "../../../../../utils/forms/components/FormGrid";
import Form from "../../../../../utils/forms/components/Form";
import * as Yup from "yup";

import "./PasswordInput.component.scss";
import { keyAPI } from "../../../api/api";

interface PasswordInputProps {
    onGetKey?: (key: string) => void;
    counterKey;
}

const VISIBLE_PASSWORD = {
    icon: "eye-light",
    type: "text"
};

const HIDDEN_PASSWORD = {
    icon: "eye-slash-light",
    type: "password"
};

const basicKeyFormFields: FormGridField[] = [
    {
        name: "use",
        fieldType: "select",
        fieldOptions: {
            id: "use",
            noValueLabel: "Choose the reason to get key...",
            label: "Usage",
            items: [
                {
                    label: "Backup database",
                    value: "Backup database"
                },
                {
                    label: "Reset Technician User",
                    value: "Reset Technician User"
                },
                {
                    label: "Reset Progressive Value",
                    value: "Reset Progressive Value"
                },
                {
                    label: "Reset Pig Boom Value",
                    value: "Reset Pig Boom Value"
                },
                {
                    label: "Reset Mr. Champion Value",
                    value: "Reset Mr. Champion Value"
                },
                {
                    label: "Reset Manny Bucks Value",
                    value: "Reset Mr. Champion Value"
                },
                {
                    label: "Reset System Server",
                    value: "Reset System Server"
                },
                {
                    label: "Save Logs (Without Login)",
                    value: "Save Logs (Without Login)"
                },
                {
                    label: "Manage Disk Space (Logs)",
                    value: "Manage Disk Space (Logs)"
                },
                {
                    label: "Network Reconfiguration",
                    value: "Network Reconfiguration"
                },
                {
                    label: "Debug Prizes",
                    value: "Debug Prizes"
                },
                {
                    label: "Restore Prizes Values",
                    value: "Restore Prizes Values"
                }
            ],
            multipleSelection: false
        },
        validation: Yup.string().nullable().required("Field is required."),
        columnClass: "col-9"
    },
    {
        name: "notes",
        fieldType: "textarea",
        fieldOptions: {
            id: "notes",
            noValueLabel: "Notes",
            label: "Notes"
        },
        validation: Yup.string().nullable().max(150, "Max. 150 characters."),
        columnClass: "col-9"
    }
];

const PasswordInput = (props: PasswordInputProps) => {
    const [enabledButton, setEnabledButton] = useState(false);
    //const [linkCopied, setLinkCopied] = useState(false);

    const [passwordVisibility, setPasswordVisibility] =
        useState(HIDDEN_PASSWORD);
    const [password, setPassword] = useState("");
    const [useValid, setUseValid] = useState(false);
    const [usage, setUsage] = useState("");
    const [notes, setNotes] = useState("");

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const password = event.target.value.replace(/\s+/g, "");
        if (event.currentTarget.value.includes(" ")) {
            event.currentTarget.value = event.currentTarget.value.replace(
                /\s/g,
                ""
            );
        }
        setEnabledButton(password.length > 0 && useValid == true);
        setPassword(password);
    };

    const onFormChange = (event: React.ChangeEvent<Form>) => {
        setUseValid(event["isValid"]);
        setUsage(event["values"]["use"]);
        setNotes(event["values"]["notes"] ? event["values"]["notes"] : "");
        setEnabledButton(password.length > 0 && event["isValid"] == true);
    };

    const onVisibilityClick = () => {
        setPasswordVisibility(
            passwordVisibility.icon === "eye-slash-light"
                ? VISIBLE_PASSWORD
                : HIDDEN_PASSWORD
        );
    };

    const onCopyButtonClick = () => {
        const el = document.createElement("textarea");
        el.value = props.counterKey;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        ToasterService.successToast("Key Copied!");
    };

    const onGenerateButtonClick = () => {
        keyAPI
            .getCounterKey({ password, usage, notes })
            .then(response => props.onGetKey(response.data))
            .catch(error => console.log({ error }));
    };

    const ref = useRef();

    return (
        <div key="key-generator" className="key-generator-container">
            <div className="form-usage">
                <Form
                    ref={ref}
                    fields={basicKeyFormFields}
                    initialValues={{}}
                    onChange={onFormChange}
                />
            </div>
            <div className="label-tooltip">
                <label className="label" htmlFor="key-generator-input">
                    Password
                </label>
            </div>
            <div className="row">
                <div className="input-group">
                    <input
                        type="text"
                        className="input key-generator-input"
                        id="key-generator-input"
                        onChange={onInputChange}
                        placeholder="Insert Hall Password"
                    />
                    {/*<div
                        className="input-group-append"
                        onClick={onVisibilityClick}
                    >
                        <span className="input-group-text">
                            <i
                                className={`icon-${passwordVisibility.icon}`}
                            ></i>
                        </span>
                    </div>*/}
                </div>
            </div>

            <div className="key-result">
                {props.counterKey !== null && (
                    <p className="editing-key">{props.counterKey}</p>
                )}
            </div>

            <div>
                <button
                    className="red-btn generate-key-btn"
                    disabled={!enabledButton}
                    onClick={onGenerateButtonClick}
                >
                    Generate Key
                </button>
                <button
                    className="red-btn copy-key-btn"
                    disabled={props.counterKey === null}
                    onClick={onCopyButtonClick}
                >
                    Copy
                </button>
            </div>
        </div>
    );
};

export default PasswordInput;
